var React = require('react');

function Glass (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#3b3b3b","d":"M42.5 12.6c-.3-3-.8-6.1-1.4-9-.4-2.1-2.3-3.6-4.4-3.6H6.3c-2.2 0-4 1.5-4.4 3.6-.6 3-1.1 6-1.4 9-.9 8-.8 18.2 2.8 27 3.4 8.6 4.1 18 2.2 27C5 69 6.6 71.4 9 71.9c.1.1.4.1.7.1h23.5c2.5 0 4.5-2 4.5-4.5 0-.3 0-.6-.1-.9-2-9-1.2-18.4 2.2-27 3.5-8.8 3.6-19 2.7-27zM5.4 4.3c.1-.4.5-.7.9-.7h30.5c.4 0 .8.3.9.7.4 2 1 4.9 1.3 8.3H4.1c.3-3.4.9-6.3 1.3-8.3zm31.1 34c-3.6 9.2-4.4 19.4-2.3 29.1.1.3 0 .5-.2.7-.2.2-.4.3-.7.3H9.8c-.3 0-.5-.1-.7-.3-.2-.2-.2-.5-.2-.7 2.1-9.7 1.3-19.8-2.3-29.1-2.4-6-3.4-13.5-2.8-22.1h35.5c.5 8.5-.4 16.1-2.8 22.1z"}));
}

Glass.defaultProps = {"width":"43","height":"72","viewBox":"0 0 43 72"};

module.exports = Glass;

Glass.default = Glass;
